import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mm_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function saveAuth(token, user) {
  localStorage.setItem("mm_token", token);
  localStorage.setItem("mm_user", JSON.stringify(user));
}

export function clearAuth() {
  localStorage.removeItem("mm_token");
  localStorage.removeItem("mm_user");
  localStorage.removeItem("mm_active_guild");
}

export function getUser() {
  try { return JSON.parse(localStorage.getItem("mm_user") || "null"); } catch { return null; }
}

export function isAuthed() {
  return !!localStorage.getItem("mm_token");
}
